import request from "./curl";
import crop_image_dialog  from "../components/crop_image_dialog";

export default {
  name: 'chatgrp_edit',
  components:{crop_image_dialog},
  data () {
    return {
      title:'Chat group edit',
      data:{},
      valid: false,
      err_msg: '',
      cropImagedialog:false,
      file_src:'',
      file_ext: '',
      file:{},
      snackbar: false,
      groupNameRules:[
        v => !!v || 'Group Name is Mandatory', 
        // v => /^[A-Za-z0-9 ]+$/.test(v) || "Special characters not allowed"
      ],
      groupDescriptionRules: [
        // v => !!v || 'Group Description is Mandatory'
      ],
      grp_details:[],
      selectedGroupKey:'',
      edit_loading:false,
      delete_loading:false
    }
  },
  mounted() {
    this.get_group_details();
  },
  computed: {
    userData() {
      return this.$store.getters.userData;
    },
    async selectedGroup() {
      return await this.$store.getters.selectedGroup;
    },
    async getChatgrpList(){
      return await this.$store.getters.getChatgrpList;
    },    
  },
  methods: {
    /**
     * open_image_dialog
     * 
     */       
    open_image_dialog(e) { 
      if(e.target.files.length > 0){
        let file = e.target.files[0];
        this.file_src = file;
        this.file_ext = file.type;
        this.cropImagedialog=true;
      }
      else{
        this.cropImagedialog=false;
      }
    },
    /**
     * get_group_details
     * Get from LS, else via API
     */
    async get_group_details() {
      this.grp_details = await this.getChatgrpList;
      if(this.grp_details && this.grp_details.length > 0) {
        this.grp_details.forEach(async (group, key)=>{
          if(group.group_id === await this.selectedGroup){
            group.group_description = decodeURIComponent(group.group_description);
            this.data = group;            
            this.selectedGroupKey = key;
          }
        })
      }
      else {
        //If group not found in LS then fetch
        this.chatgrp_details();
      }
    },
    /**
     * chatgrp_details
     */
    async chatgrp_details() {
      let selectedGroupId = await this.selectedGroup;
      if(selectedGroupId){
        var post_data = new FormData();
        post_data.append("chat_user_id", this.userData.user_id);
        post_data.append("group_id", selectedGroupId);

        request.curl(this, "group_view", post_data)
        .then(response => {
          if(response.resp_status){
            this.data = response.resp_data;
          }
        });
      }
    },
    /**
     * chatgrp_edit
     * Call Edit API
     */      
    async chatgrp_edit() {
      if (this.$refs.form.validate()) {
        this.edit_loading=true;
        var group_id = await this.selectedGroup;

        var post_data = new FormData();
        post_data.append('group_id', group_id);
        post_data.append('chat_user_id', this.userData.user_id);
        post_data.append('group_name', this.data.group_name);
        post_data.append('group_description', this.data.group_description);
        if (this.file) {
          post_data.append("file", this.file);
        }
        post_data.append("file_ext", this.file_ext)

        request.curl(this, "group_edit", post_data)
        .then(async response => {
          if(response.resp_status){
            if(response.resp_data.groupInfo.group_icon){
              this.data.group_icon = response.resp_data.groupInfo.group_icon;
            }
            
            this.grp_details[this.selectedGroupKey] = this.data;
            await this.$store.commit('setChatgrpList', this.grp_details);
            
            this.$router.go(-1);
          }
          else{
            this.err_msg = response.resp_msg;
            this.snackbar = true;
          }
          this.edit_loading = false;
        });
      }
      else{
        this.err_msg = 'Please fill all the required fields.';
        this.snackbar = true;
      }
    },  
    /**
     * getImageSrc
     * 
     */
    getImageSrc(img){
      this.$refs.image.src = img;
    },
    /**
     * setImageSrc
     * 
     */
    setImageSrc(src){
      this.file_src = src;
    },
    /**
     * getImageFile
     * 
     */
    getImageFile(file){
      this.file = file;
    },
    /**
     * dialogClose
     * 
     */
    dialogClose(value){
      this.cropImagedialog = value;
    }
  }
}
